module.exports = __webpack_public_path__ + "static/media/dustbin.22c14b4f.svg";